import { BannerService } from '@common/lib/api';
import * as banner from './types';

const actions = {
  async [banner.CLICK_VIEW_BANNER](context, params) {
    await BannerService.clickBanner(params);
  },
};

export default actions;
